// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {IconName} from '@wandb/weave/components/Icon';
import React, {cloneElement, ReactElement, useCallback, useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Modal} from 'semantic-ui-react';

type ModalTriggerButtonProps =
  | {
      modalHeader: string;
      modalContent: JSX.Element;
      modalDataTest?: string;
      buttonIcon: IconName;
      buttonText: string;
      onClick?: () => void;
    }
  | {
      modalHeader: string;
      modalContent: JSX.Element;
      modalDataTest?: string;
      buttonElement: ReactElement;
      onClick?: () => void;
    };

export const ModalTriggerButton = (props: ModalTriggerButtonProps) => {
  const {modalContent, modalHeader, modalDataTest, onClick} = props;
  const [showModal, setShowModal] = useState(false);
  const openModal = useCallback(() => setShowModal(true), [setShowModal]);
  const closeModal = useCallback(() => setShowModal(false), [setShowModal]);

  let button;
  if ('buttonElement' in props) {
    button = cloneElement(props.buttonElement, {
      onClick() {
        openModal();
        onClick?.();
      },
    });
  } else {
    const {buttonIcon, buttonText} = props;
    button = (
      <Button
        icon={buttonIcon}
        variant="secondary"
        twWrapperStyles={{display: 'inline'}}
        onClick={() => {
          openModal();
          onClick?.();
        }}>
        {buttonText}
      </Button>
    );
  }

  return (
    <React.Fragment>
      {/* COLUMNS CONFIG */}
      <Modal
        className="small"
        data-test={modalDataTest}
        trigger={button}
        open={showModal}
        onClose={closeModal}>
        <Modal.Header>{modalHeader}</Modal.Header>
        <Modal.Content>{modalContent}</Modal.Content>
        <Modal.Actions>
          <Button onClick={closeModal}>Close</Button>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  );
};
